import { render, staticRenderFns } from "./create-purchase-order.vue?vue&type=template&id=24d953dc&"
import script from "./create-purchase-order.vue?vue&type=script&lang=ts&"
export * from "./create-purchase-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports